import React from 'react';
import CartFreeDeliveryInfo from './CartFreeDeliveryInfo';
import CartMinDeliveryInfo from './CartMinDeliveryInfo';
import { getMinimumCartAmount } from 'Utils/restaurant';
import Shapes from 'Shapes';
import BasketStatus from 'Utils/basket-status';
import CartTotalRow from './CartTotalRow';
var CartDeliveryInfo = function (props) {
    var basketStatus = props.basketStatus, restaurant = props.restaurant;
    var minCartAmount = getMinimumCartAmount(restaurant, basketStatus);
    var basketFreeDelivery = BasketStatus.getFreeDeliveryUpselling(basketStatus);
    var minDeliveryUpselling = BasketStatus.getMinDeliveryUpselling(basketStatus);
    var isCartSumEnoughForDelivery = BasketStatus.getIsMinDeliveryAchieved(basketStatus);
    return (React.createElement(React.Fragment, null, isCartSumEnoughForDelivery ? (React.createElement(React.Fragment, null,
        React.createElement(CartTotalRow, { label: "Koszt dostawy", value: basketStatus.price.delivery }),
        React.createElement(CartFreeDeliveryInfo, { currentDeliveryPrice: basketStatus.price.delivery, freeDeliveryData: basketFreeDelivery, spanClassName: "text-primary" }),
        React.createElement(CartTotalRow, { label: "Razem", last: true, value: basketStatus.price.withDelivery }))) : (React.createElement(CartMinDeliveryInfo, { divClassName: "text-danger", minCartAmount: minCartAmount, missingCart: (minDeliveryUpselling === null || minDeliveryUpselling === void 0 ? void 0 : minDeliveryUpselling.value) || null }))));
};
CartDeliveryInfo.propTypes = {
    basketStatus: Shapes.basketStatusShape.isRequired,
    restaurant: Shapes.deliveryRestaurantShape,
};
export default CartDeliveryInfo;
